import styled from 'styled-components';

export const TrackName = styled.h3`
  color: #fff;
  font-size: 6.6vw;
  font-weight: 600;
  font-family: 'Barlow Condensed';
  line-height: 1.4;
  margin: 0;
`;

export const EventName = styled.p`
  display: inline;
  color: #fff;
  line-height: 28px;
  font-weight: 600;
  font-family: Barlow Condensed;
  text-align: left;
  font-size: 6.6vw;
  line-height: 28px;
  margin: 0;
`;
